import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';

@Component({
  selector: 'app-turno-cancelado',
  templateUrl: 'turno-cancelado.component.html',
})
export class TurnoCanceladoComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {

  }
}


// WEBPACK FOOTER //
// /opt/snt/front-end-turnos/src/app/turnos/shared/turno-cancelado/turno-cancelado.component.ts